export default __webpack_public_path__ + "static/media/telegram.fd2e24d4.png";